




























































































































import { genVuexComputeds } from '@/main/pages/editFactory';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { InterniDruh } from '@/modules/ciselnik/dilenske/internidruh';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';

import { store } from '../store/edit';
import { types } from '../store/types';

export default PageModeMixin.extend({
	name: 'FirmaNastaveni1',
	components: {
		DodavatelSelect: Dodavatel.components.Select,
		InterniDruhSelect: InterniDruh.components.Select,
	},
	props: {
		storeUri: { type: String, default: null },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				dodavatel: `${this.storeUri}/${types.mutations.FN1_DODAVATEL_SELECT_MAPPER}`,
				interniDruh: `${this.storeUri}/${types.mutations.INTERNI_DRUH_SELECT_MAPPER}`,
				skladPrevodInterniDruh: `${this.storeUri}/${types.mutations.SKLAD_PREVOD_INTERNI_DRUH_SELECT_MAPPER}`,
			};
		},
	},
});
